import React from 'react';

var ArtworkBuilding = function ArtworkBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 120",
    className: props === null || props === void 0 ? void 0 : props.className
  }, /*#__PURE__*/React.createElement("rect", {
    width: "170",
    height: "120",
    fill: "#F2F3F4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18750_46046",
    maskUnits: "userSpaceOnUse",
    x: "49",
    y: "24",
    width: "72",
    height: "72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "49",
    y: "24",
    width: "72",
    height: "72",
    fill: "#E5E7E9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18750_46046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 87V33H85V45H115V87H55ZM61 81H79V75H61V81ZM61 69H79V63H61V69ZM61 57H79V51H61V57ZM61 45H79V39H61V45ZM85 81H109V51H85V81ZM91 63V57H103V63H91ZM91 75V69H103V75H91Z",
    fill: "#E5E7E9"
  })));
};

export { ArtworkBuilding, ArtworkBuilding as default };
//# sourceMappingURL=artwork-building.esm.js.map
